/** «Север» from «Автосервис «Север»» — the mark's name, not the full title. */
export function shortName(name: string): string {
  return /[«"]([^»"]+)[»"]/.exec(name)?.[1] ?? name
}

/** The first letter that is a letter: «Север» in quotes still gives «С». */
export function monogram(name: string): string {
  return /\p{L}/u.exec(shortName(name))?.[0]?.toUpperCase() ?? '•'
}
